import { createSelector } from "reselect";

const locationsSelector = createSelector(
  (locations) => locations,
  (locations) => {
    const colors = {};
    locations.forEach((l) => {
      colors[l.vehicleId] = l.color;
    });

    return colors;
  }
);

export default locationsSelector;
